import React from 'react'
import {
    StyledThumbnailSection,
    StyledThumbnailLink,
    StyledThumbnailContainer,
} from 'component-library/content/Gallery/Gallery.styled'
import { Picture } from 'component-library/content/Picture/Picture'
import { breakpoint, calcRem } from 'component-library/__styling/style-functions'
import { metrics } from 'component-library/__styling/settings'
import { StyledButton } from 'component-library/buttons/Button/Button.styled'
import { ImageWidths } from 'common/helpers/image'
import { css } from '@emotion/css'
import { Theme } from 'component-library/__styling/themes'
import {
    ImageSizeTypes,
    getImageSizePropsFromType,
} from 'component-library/content/Picture/layouts/helpers/sizes'
import { ImageSourceWithCaptions } from 'common/client-data-types/image-item'
import { GalleryEvent } from 'common/events/publication-events'
import { DataLayerEventName } from 'common/helpers/DataLayerEventName'

export interface Props {
    theme: Theme
    images: ImageSourceWithCaptions[]
    onEvent: (event: GalleryEvent) => void
    scrollTo: (imageIndex: number) => void
    toggleThumbnails: () => void
    imageWidths: ImageWidths['thewest'] | ImageWidths['perthnow']
}

export const GalleryThumbnails: React.FC<Props> = ({
    theme,
    images,
    onEvent,
    scrollTo,
    toggleThumbnails,
    imageWidths,
}) => (
    <StyledThumbnailContainer>
        <StyledThumbnailSection>
            {images.map((img, i) => (
                <StyledThumbnailLink
                    key={i}
                    onClick={() => {
                        onEvent({
                            type: DataLayerEventName.galleryThumbnailClick,
                            originator: 'Gallery',
                            payload: {
                                imageIndex: i + 1,
                            },
                        })
                        scrollTo(i)
                    }}
                >
                    <Picture
                        layout="fill-container-horizontally"
                        image={img}
                        fixedRatio={img.crops['16:9'] ? '16:9' : 'original'}
                        imageWidths={imageWidths}
                        imageSizes={getImageSizePropsFromType(
                            theme.kind,
                            ImageSizeTypes.GalleryThumbnail,
                            imageWidths
                        )}
                    />
                </StyledThumbnailLink>
            ))}
        </StyledThumbnailSection>
        <StyledButton
            onClick={toggleThumbnails}
            className={css({
                margin: `0 auto`,

                [breakpoint('xs')]: {
                    margin: `0 ${calcRem(metrics.perthnow.margins.lg)} 0 auto`,
                },
            })}
        >
            Hide Thumbnails
        </StyledButton>
    </StyledThumbnailContainer>
)
